import { render, staticRenderFns } from "./DashboardNivelTensaoVisaoUnidadeConsumidora.vue?vue&type=template&id=8c4f74aa&"
import script from "./DashboardNivelTensaoVisaoUnidadeConsumidora.vue?vue&type=script&lang=js&"
export * from "./DashboardNivelTensaoVisaoUnidadeConsumidora.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNivelTensaoVisaoUnidadeConsumidora.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VCard,VCardText,VCardTitle,VCol,VDataTable,VRow,VSelect,VSwitch})
